module.exports = __webpack_public_path__ + "img/vtb.62a5961.png";